export default __webpack_public_path__ + "static/media/Kathy Watanabe.d85562f6.png";